import { createPolicyInstance } from './js/harden-policy-instance';
import { dispatchManagerReadyEvent } from './js/events';
import { ConsentPolicyManager } from './js/consent-policy-manager';

if (typeof window !== 'undefined') {
  const consentPolicyManager = new ConsentPolicyManager();
  createPolicyInstance(consentPolicyManager);

  dispatchManagerReadyEvent()
}
